import type { ProductConfig } from '#types/config/components/product'
import type { RecursivePartial } from '#types/utils'

export default {
  brandClasses: {
    container: 'flex items-center gap-2 b b-grey-80 rounded-xs bg-grey-90 px-4 py-3',
    cta: 'mt-4',
    price: 'mt-1'
  },
  buttonSize: 'tiny',
  buttonVariant: 'tertiary',
  dialogOptions: {
    type: 'panel'
  },
  image: {
    height: 120,
    width: 120
  }
} satisfies RecursivePartial<ProductConfig['upsell']>
